import { Storage } from 'aws-amplify';

import { useDataSetters, useDataState } from '../../../../DataContext';

export async function getJsonFromS3(filepath) {

  try {
    const signedUrl = await Storage.get(filepath, { download: false, customPrefix: { public: '' } });
    const response = await fetch(signedUrl);
    if (response.status !== 200) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const jsonData = await response.json();

    return jsonData;
  } catch (error) {
    console.error('Error getting JSON from S3:', error);
    return null;
    // throw error; // Rethrow the error for the caller to handle
  }
}

export async function saveJsonToS3(filepath, jsonData) {
  try {
    const jsonString = JSON.stringify(jsonData);
    await Storage.put(filepath, jsonString, {
      contentType: 'application/json',
      customPrefix: { public: '' }
    });
    console.log('JSON saved to S3:', filepath);
  } catch (error) {
    console.error('Error saving JSON to S3:', error);
    throw error; // Rethrow the error for the caller to handle
  }
}